const primaryColor = 'rgba(28, 192, 160, 1)'; 
const greyColor = "#F3F3F3";
export {
    primaryColor,
    greyColor
}